<template>
  <div class="layout-row" style="min-height: 100vh;">
           <!-- ############ Aside START-->
        <div id="aside" class="page-sidenav no-shrink bg-light nav-dropdown fade" aria-hidden="true">
            <div class="sidenav h-100 bg-light modal-dialog">
                <!-- sidenav top -->
                <div class="navbar">
                    <!-- brand -->
                    <router-link to="/" class="navbar-brand" tag="a">
                        <img src="../assets/pragma_logo_alternative.png" width="192">
                        <!--
                        <svg width="32" height="32" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
                            <g class="loading-spin" style="transform-origin: 256px 256px">
                                <path d="M200.043 106.067c-40.631 15.171-73.434 46.382-90.717 85.933H256l-55.957-85.933zM412.797 288A160.723 160.723 0 0 0 416 256c0-36.624-12.314-70.367-33.016-97.334L311 288h101.797zM359.973 134.395C332.007 110.461 295.694 96 256 96c-7.966 0-15.794.591-23.448 1.715L310.852 224l49.121-89.605zM99.204 224A160.65 160.65 0 0 0 96 256c0 36.639 12.324 70.394 33.041 97.366L201 224H99.204zM311.959 405.932c40.631-15.171 73.433-46.382 90.715-85.932H256l55.959 85.932zM152.046 377.621C180.009 401.545 216.314 416 256 416c7.969 0 15.799-.592 23.456-1.716L201.164 288l-49.118 89.621z"></path>
                            </g>
                        </svg> 
                        <span class="hidden-folded d-inline l-s-n-1x ">PragmaPredict</span> -->
                    </router-link>
                    <!-- / brand -->
                </div>
                <!-- Flex nav content -->
                <div class="flex scrollable hover">
                    <div class="nav-active-text-primary" data-nav>
                        <ul class="nav bg">
                            <li>
                                <router-link to="/" exact tag="a">
                                    <span class="nav-icon"><home-icon class="custom-class" width="16" height="16"></home-icon></span>
                                    <span class="nav-text">Dashboard</span>
                                </router-link>
                            </li>
                            <li>
                                <router-link to="/personas" tag="a">
                                    <span class="nav-icon"><users-icon class="custom-class" width="16" height="16"></users-icon></span>
                                    <span class="nav-text">Personas</span>
                                </router-link>
                            </li>
                            <li>
                                <router-link to="/integrations" tag="a">
                                    <span class="nav-icon"><server-icon class="custom-class" width="16" height="16"></server-icon></span>
                                    <span class="nav-text">Integrations</span>
                                </router-link>
                            </li>
                            <li>
                                <router-link to="/settings" tag="a">
                                    <span class="nav-icon"><settings-icon class="custom-class" width="16" height="16"></settings-icon></span>
                                    <span class="nav-text">Settings</span>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- ############ Aside END-->
        <div id="main" class="layout-column flex">
            <div id="header" class="page-header ">
                <div class="navbar navbar-expand-lg">
                    <!-- Navbar collapse -->
                    <ul class="nav navbar-menu order-1 order-lg-2">
                        <!-- User dropdown menu -->
                        <li class="nav-item dropdown">
                            <a href="#" data-toggle="dropdown" class="nav-link d-flex align-items-center px-2 text-color">
                                <span class="avatar w-24" style="margin: -2px;">
                                    <img src="../../static/assets/img/a3.jpg" alt="">
                                </span>
                            </a>
                            <div class="dropdown-menu dropdown-menu-right w mt-3 animate fadeIn">
                                <a class="dropdown-item" href="#">
                                    <span>{{username}}</span>
                                </a>
                                <div class="dropdown-divider"></div>
                                <router-link class="dropdown-item"  to="/settings" tag="a">
                                    <span>Account Settings</span>
                                </router-link>
                                <a class="dropdown-item" :href="logout_link" @click="logout()">Sign out</a>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <transition name="page" mode="out-in">
                <keep-alive>
                    <router-view></router-view>
                </keep-alive>
            </transition>
        </div>
    </div>
</template>

<script type="text/javascript">
import { ServerIcon, UsersIcon, SettingsIcon, HomeIcon} from 'vue-feather-icons'
import {getUser} from '@/utils/auth';

export default{
  components: {
    ServerIcon,
    UsersIcon,
    SettingsIcon,
    HomeIcon
  },
  data() {
    return {
      username: '',
      logout_link: process.env.API_LOCATION +'/logout?redirect_to='+ encodeURIComponent(process.env.APP_LOCATION),
    };
  },

  methods: {

    logout() {
      localStorage.removeItem("user");
      localStorage.removeItem("expiration_date");
      this.$router.push(logout_link);
    },
  },

  created() {
    getUser().then(response =>{
       var user = response.data;
       this.username = user['name'];
    })
    .catch(error => {
       console.log(error)
    })
  },
};

</script>

<style>
.page-enter-active, .page-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}
.page-enter, .page-leave-to {
  opacity: 0;
  transform: translateX(-30%);
}

li > a.router-link-active {
    font-weight: bold;
    text-decoration: underline;
}

a.router-link-active > .nav-icon {
    opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue